/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { useStore } from 'src/onboarding/store/store';
import { ReactComponent as HumanMen } from '../../assets/images/humanMen.svg';
import { ReactComponent as Human } from '../../assets/images/human.svg';
interface ParameterItem {
  value: string;
  label: string;
}

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const gender = useStore((state) => state.gender);

  const PARAMETERS: ParameterItem[] = [
    { value: '18.8', label: t('onboarding.analyzeBody.bmi') },
    { value: '24', label: t('onboarding.analyzeBody.bfp') },
    { value: '0.71', label: t('onboarding.analyzeBody.whr') },
  ];

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.wrapperInfo}>
          <Title className={styles.title}>{t('onboarding.analyzeBody.title')}</Title>
          <div className={styles.bodyContent}>
            <div className={styles.bodyTypeContainer}>
              <div className={styles.bodyType}>
                <span></span>
                <Caption size='s'>{t('onboarding.analyzeBody.bodyType')}</Caption>
              </div>
              <Text size='s' semibold>
                {t('onboarding.analyzeBody.hourglass')}
              </Text>
            </div>
            <div className={styles.parameters}>
              {PARAMETERS.map((item, index) => (
                <div className={styles.parameterItem} key={index}>
                  <div className={styles.parameterValue}>{item.value}</div>
                  <div className={styles.parameterLabel}>{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {gender === 'Male' ? (
          <HumanMen className={styles.image} />
        ) : (
          <Human className={styles.image} />
        )}
        <div className={styles.scanLine}></div>
      </div>
      <div className={styles.continue}>
        <div className={styles.blur}></div>

        <Button onClick={onNext} title={t('onboarding.analyzeBody.continue')} />
      </div>
    </div>
  );
}

export default Page;
